<template>
<div v-if="this.modal">
    <div :class="{'content p-4': this.border}"> 
    <h5 class="neue-roman">{{ this.message }}</h5>
    <div class="table-responsive col-12 p-0 mt-3">
        <table class="table table-borderless neue-roman m-0">
            <tbody class=''>
                <tr>
                    <td class="align-middle p-0 light mw_130" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.3') }} </span>
                    </td>
                    <td v-if="this.loading && !this.get_transact" class="align-middle neue p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <div  class="loader-div"><slot name="loader"></slot></div>
                    </td>
                    <td v-if="this.get_transact" class="align-middle neue p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <span class="d-flex flex-row align-items-center">{{this.get_transact}} <i class='item-i ml-1 copy c18 cli_transact pointer' @click="copy(this.get_transact)"></i></span>
                    </td>
                </tr>
                <tr>
                    <td  class="align-middle p-0 light mw_130" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.1') }} </span>
                    </td>
                    <td v-if="this.loading && !this.get_sum" class="align-middle neue p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <div  class="loader-div"><slot name="loader"></slot></div>
                    </td>
                    <td v-if="this.get_sum" class="align-middle neue-roman p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <span>{{this.get_sum}}</span>
                    </td>
                </tr>
                <tr v-if="this.get_sum2 && this.get_sum != this.get_sum2">
                    <td class="align-middle p-0 light mw_130" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.1') }} </span>
                    </td>
                    <td v-if="this.loading && !this.get_sum2" class="align-middle neue p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <div  class="loader-div"><slot name="loader"></slot></div>
                    </td>
                    <td v-if='this.get_sum2' class="align-middle neue-roman p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <span>{{this.get_sum2}}</span>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle p-0 light mw_130" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.2') }}</span>
                    </td>
                    <td v-if="this.loading && !this.get_res" class="align-middle neue p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <div  class="loader-div"><slot name="loader"></slot></div>
                    </td>
                    <td v-if="this.get_res" class="align-middle neue-roman p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <span>{{this.get_res}}</span>
                    </td>
                </tr>
                <tr v-if="this.exp_post && (Number(this.get_done) != -2 || Number(this.get_done) != -3)">
                    <td class="align-middle p-0 light mw_130" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.6') }}</span>
                    </td>
                    <td v-if="this.exp_post[0] && !this.exp_post[0]['hash']" class="align-middle neue p-0 d-flex align-items-center justify-content-start pl-1" scope="col">
                        <CustomLoader
                            :is-full-page="false"
                            :height='20'
                            :width='50'
                            :type='"dots"'
                            :opacity='0'
                            :no_text="true"
                        />
                    </td>
                    <td v-if="this.exp_post.length > 0 && this.exp_post[0]['hash']" class="align-middle neue-roman p-0 d-flex flex-column align-items-start justify-content-start pl-1" scope="col">
                        <div v-for="(row, index) in this.exp_post" :key="index">
                            <span class="grey break-word break-all">{{ row.hash }}<input type='hidden' :id='"_h" + index' :value="row.hash"/></span>
                            <span style="position: relative;"><a v-if='row.explorer_link' style="display: inline-block; position: absolute; top: -1px;" :href="row.explorer_link" target="_blank"><i class='item-i c18 ml-2 ext-link'></i></a></span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="mt-3" v-if="this.get_done === '0'" >
            <Button class='' :name="$t('components.service.PayStatusTemplate.4')" type='btn-outline-warning' v-on:click='this.getParamsExtTransact'/>
        </div>
    </div>
    </div>
    <h4 class='neue-roman mt-3'>{{ $t('components.service.PayStatusTemplate.5') }}</h4>
    <slot name="links">
    </slot>
</div>
<div v-else>
    <div :class="{'content p-4': this.border}"> 
    <div class="table-responsive col-12 p-0">
        <table class="table table-borderless neue-roman m-0" >
            <tbody :class="{'fsp14': isMobile, 'fsp16': !isMobile}">
                <tr class="lh32">
                    <td class="align-middle pt-0 pl-0 neue-roman" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.3') }} </span>
                    </td>
                    <td v-if="this.get_transact" class="align-middle neue d-flex align-items-center pt-0 pr-0 justify-content-end pl-1" scope="col">
                        <span class="d-flex flex-row align-items-center">
                            {{this.get_transact}} 
                            <Icon name="copy" class="c18 ml8" @click="copy(this.get_transact)" />
                        </span>
                    </td>
                </tr>
                <tr class="lh32">
                    <td  class="align-middle pt-0 pl-0 neue-roman" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.1') }} </span>
                    </td>
                    <td v-if="this.get_sum" class="align-middle neue d-flex align-items-center pt-0 pr-0 justify-content-end pl-1" scope="col">
                        <span>{{this.get_sum}}</span>
                    </td>
                </tr>
                <tr v-if="this.get_sum2 && this.get_sum != this.get_sum2" class="lh32">
                    <td class="align-middle pl-0 pt-0" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.1') }} </span>
                    </td>
                    <td v-if="this.loading && !this.get_sum2" class="align-middle neue  d-flex align-items-center pt-0 justify-content-end pl-1" scope="col">
                        <div  class="loader-div"><slot name="loader"></slot></div>
                    </td>
                    <td v-if='this.get_sum2' class="align-middle neue-roman d-flex align-items-center pt-0 justify-content-end pl-1" scope="col">
                        <span>{{this.get_sum2}}</span>
                    </td>
                </tr>
                <tr class="lh32">
                    <td class="align-middle neue-roman pt-0 pl-0" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.2') }}</span>
                    </td>
                    <td v-if="this.loading && !this.get_res" class="align-middle neue  d-flex align-items-center pt-0 pr-0 justify-content-end pl-1" scope="col">
                        <div class="h32 neue bg-light-orange color-orange px24 rounded-pill fsp16">{{ $t('components.service.PayStatusTemplate.7') }}</div>
                    </td>
                    <td v-if="this.get_res" class="align-middle neue-roman d-flex align-items-center pt-0 pr-0 justify-content-end pl-1" scope="col">
                        <span 
                            class="h32 neue bg-light-orange color-orange px24 rounded-pill fsp16"
                            :class="{
                                'bg-light-green color-green': this.get_done !== '0' && !this.error, 
                                'bg-light-orange color-orange': this.get_done === '0' && !this.error,
                                'bg-light-red color-red': this.error
                            }"
                        >
                            <span v-if="this.error">{{ $t('components.service.PayStatusTemplate.9') }}</span>
                            <span v-else>{{this.get_done === '0' ? $t('components.service.PayStatusTemplate.7') : $t('components.service.PayStatusTemplate.8')}}</span>
                        </span>
                    </td>
                </tr>
                <tr v-if="this.exp_post && (Number(this.get_done) != -2 || Number(this.get_done) != -3)" class="lh32">
                    <td class="align-middle neue-roman p-0" scope="col">
                        <span>{{ $t('components.service.PayStatusTemplate.6') }}</span>
                    </td>
                    <td v-if="this.exp_post[0] && !this.exp_post[0]['hash']" class="align-middle neue d-flex align-items-center pt-0 pb-0 pr-0 justify-content-end pl-1" scope="col">
                        <div class="h32 neue bg-light-orange color-orange px24 rounded-pill">{{ $t('components.service.PayStatusTemplate.7') }}</div>
                    </td>
                    <td v-if="this.exp_post.length > 0 && this.exp_post[0]['hash']" class="align-middle neue-roman d-flex flex-column p-0 align-items-start justify-content-end pl-1" scope="col">
                        <div v-for="(row, index) in this.exp_post" :key="index" class="d-flex align-items-center justify-content-end w-100">
                            <span class="neue mb-0">{{ sized(row.hash) }}<input type='hidden' :id='"_h" + index' :value="row.hash"/></span>
                            <a v-if='row.explorer_link' :href="row.explorer_link" target="_blank">
                                <Icon name="external-link" class="ml4 c18" />
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <h5 class="neue-roman primary-grey mt24 mb24" :class="{ 'fsp14 lh20': isMobile, 'fsp16 lh24': !isMobile }">{{ this.message }}</h5>
    </div>
    </div>
    <h4 class='neue fsp20 lh28 pt24 border-t mb24'>{{ $t('components.service.PayStatusTemplate.5') }}</h4>
    <slot name="links"></slot>
    <slot name="buttons"></slot>
</div>
</template>

<script>
    import Button from '@/components/service/Button';
    import CustomLoader from '@/components/service/CustomLoader';
    import Icon from '@/components/icons/Icon';

    export default {
        components: {
            Button,
            CustomLoader,
            Icon
        },
        props: {
            message: [String, Boolean],
            get_transact: [String, Boolean],
            get_sum: [String, Boolean], 
            get_sum2: [String, Boolean], 
            get_res: [String, Boolean],
            get_done: [String, Boolean],
            border: [Boolean],
            exp_post: [Array, Boolean],
            loading: [Boolean],
            error: [Boolean],
            modal: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            isMobile() {
                return this.$store.state.resize.w <= 768;
            },
        },
        methods: {
            getParamsExtTransact() {
                this.$emit('getParamsExtTransact');
            },
            copy(text) {
                this.$lib.copyTextS(text, this.$store)
            },
            sized(str) {
                return this.$lib.getTokenString(str, 10);
            },
        }
    }
</script>

<style lang="scss" scoped>
.content {
    box-shadow: 1px 2px 4px 1px rgb(19 110 0 / 24%) !important;
}
.loader-div {
    position: relative;
    min-height: 20px;
    width: 50px;
    z-index: 2000;
}
.mw_130 {
    width: 120px;
}
.bg-light-orange {
    background-color: rgba($dark-orange, 0.2);
}
.color-orange {
    color: $dark-orange;
}
.bg-light-green {
    background-color: rgba($color-notification, 0.2);
}
.color-green {
    color: $color-notification;
}
.bg-light-red {
    background-color: rgba($color-invalid, 0.2);
}
.color-red {
    color: $color-invalid;
}
td {
    padding-bottom: 16px;
}
</style>